<script lang="ts">
  import Form from "../components/Form.svelte";
  import Caret from "~icons/ph/caret-down";
  import { domId } from "../lib/dom";

  let {
    action,
    errors,
  }:{
    action: string;
    errors: { [key: string]: string } | null;
  } = $props();

  let choice = $state(null);
  let form = $state(null);
  let confirmationScreen = $state(false);

  function hideDetails() {
    form?.querySelectorAll("details").forEach(d=>d.open = false)
  }

  const closeDialogId = domId("close-dialog");
</script>

<Form method="patch" {action} class="ui-rhythm" bind:form>
  {#if !confirmationScreen}
    <h2 class="ui-title">Choose next steps for your claim</h2>
    <p>This finance agreement is a lease or <b>Personal Contract Hire (PCH)</b> agreement, outside the scope of the current FCA investigation and proposed redress scheme. We are pursuing our own investigation to assess the best course of action for you.</p>

    <fieldset class="space-y-2">
      <legend class="mb-4">Please choose whether to stay with JLG and wait for our guidance or handle the claim yourself:</legend>

      <div class="ui-option-container relative">
        <div class="absolute -top-3 text-sm font-medium text-emerald-700 bg-emerald-100 py-[0.1250rem] px-2 rounded-badge">Recommended</div>
        <label class="flex flex-row gap-2 items-start mt-3">
          <input
            type="radio"
            name="choice"
            value="continue"
            class="radio"
            bind:group={choice}
            onchange={hideDetails}
            required
          >
          <span><b>Continue</b> with JLG while we complete our investigation</span>
        </label>

        <details class="ui-details mt-4">
          <summary><Caret /> Why does JLG recommend continuing?</summary>
          <ul class="list-disc pl-6 space-y-2 mb-4">
            <li>We’re still in investigations, and the results will let us give you the best advice: either to pursue with the Financial Ombudsman Service (FOS) or to initiate legal proceedings with JLG</li>
            <li>We should report back in the next 4–6 months, which is well within the 15-month deadline</li>
            <li>There’s no guarantee that going the FOS route will be faster</li>
            <li>If we conclude there’s no merit in pursuing your claim further, we’ll advise you accordingly</li>
          </ul>
        </details>
      </div>

      <div class="ui-option-container">
        <label class="flex flex-row gap-2 items-start">
          <input
            type="radio"
            name="choice"
            value="withdraw"
            class="radio"
            bind:group={choice}
            onchange={hideDetails}
            required
          >
          <span><b>Withdraw</b> and pursue via the Financial Ombudsman Service</span>
        </label>
        <details class="ui-details mt-4">
          <summary><Caret /> What happens if I withdraw?</summary>
          <ul class="list-disc pl-6 space-y-2 mb-4">
            <li>This formally cancels your instructions to JLG on this agreement</li>
            <li>We will not charge you for our services on this agreement</li>
            <li>We’ll give you instructions on how to pursue the matter using the Financial Ombudsman Service (FOS)</li>
          </ul>
        </details>
      </div>

      {#if errors}<div class="ui-error">{errors.general}</div>{/if}
    </fieldset>

    <div class="floating-footer">
      <button class="btn btn-ghost" form={closeDialogId}>Back</button>
      <button
        class="btn btn-primary"
        type={choice === "withdraw" ? "button" : "submit"}
        onclick={() => {if (choice === "withdraw") confirmationScreen = true}}
      >Confirm</button>
    </div>

  {:else}
    <h3 class="font-medium text-lg mb-2">Are you sure you want to withdraw your claim?</h3>
    <p class="mb-2 text-gray-500">This can’t be undone.</p>
    <input type="hidden" name="choice" value="withdraw" />

    <div class="floating-footer">
      <button class="btn btn-ghost" type="button" onclick={() => confirmationScreen = false}>Back</button>
      <button class="btn btn-error text-white" type="submit">Confirm withdrawal</button>
    </div>
  {/if}
</Form>

<form method="dialog" id={closeDialogId}></form>
